/*
 * Sticky filters offset (ECSR-924 / ECSR-925).
 *
 * Writes --sticky-filters-top: the measured bottom edge of the site header
 * while it is pinned (position sticky/fixed), 0 otherwise. The header is
 * measured rather than inferred from its classes because its scroll-state
 * classes do not describe what is actually visible on this theme.
 */
(() => {
  if (window.__stickyFiltersInit) return;
  window.__stickyFiltersInit = true;

  const root = document.documentElement;
  let header = null;
  let frame = 0;
  let lastValue = null;

  const measure = () => {
    frame = 0;
    if (!header || !header.isConnected) {
      header = document.querySelector('.section-header');
    }
    let offset = 0;
    if (header) {
      const position = window.getComputedStyle(header).position;
      if (position === 'sticky' || position === 'fixed') {
        offset = Math.max(0, Math.round(header.getBoundingClientRect().bottom));
      }
    }
    const value = `${offset}px`;
    if (value !== lastValue) {
      lastValue = value;
      root.style.setProperty('--sticky-filters-top', value);
    }
  };

  const schedule = () => {
    if (!frame) {
      frame = window.requestAnimationFrame(measure);
    }
  };

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);
  window.addEventListener('load', schedule);
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('transitionend', (event) => {
    if (header && header.contains(event.target)) {
      schedule();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', measure);
  } else {
    measure();
  }
})();
